export default __webpack_public_path__ + "static/media/0.5c2a6bc6.jpg";